import easyXDM from 'easyxdm';
import axios from 'axios';


const axiosInstance = axios.create({
    baseURL: process.env.API_URL,
    timeout: 6000,
    withCredentials: true
});

/**
 * Request user information with axios.
 *
 * @param {number} appId Application id.
 * @param callback
 */
function requestUseInfo(appId, callback) {
    axiosInstance.get(`/user/auth?app_id=${appId}&with_token=1`)
        .then(response => {
            callback(response);
        })
        .catch(e => console.error(`Failed to request user/auth, error: ${e}`));
}

const socket = new easyXDM.Socket({
    onMessage: function (message) {

        try {

            if (!/^{/gi.test(message)) {
                console.log('Cannot parse as NOT a JSON', message);
                return;
            }

            const obj = JSON.parse(message);

            const appId = obj && obj.payload && obj.payload.app_id;

            switch (obj.type) {
                case 'get_user':
                    requestUseInfo(appId, (envelope) => {
                        const message = JSON.stringify({
                            type: 'get_user',
                            payload: envelope.data.response
                        });
                        socket.postMessage(message);
                    });
                    break;
                default:
                    console.log('Unknown message: ' + message);
                    break;
            }
        } catch (e) {
            console.error(`Failed to parse ${message} as error was thrown: ${e}`);
        }


    }
});
